<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { TicketsStore, TicketStore } from '../stores'
    
    import TicketsService from '../$services/tickets.service'
    import DateMethods from '../$methods/date.methods'
    
    import EnumMethods from '../$methods/enum.methods'
    import Form from '../$components/form.svelte'
    import Textarea from '../$components/textarea.svelte'
    import Value from '../$components/value.svelte'

    const dispatch = createEventDispatcher()

    let data = {
        history: $TicketStore.history
    }

    let response = ''

    let loading = false

    async function updateTicket() {

        data.history.push({
            response: response,
            from: 'user',
            created: new Date()
        })

        loading = true
        const resp = await TicketsService.updateTicket($TicketStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        TicketsStore.replace(resp.data)
        TicketStore.set(resp.data)

        toast({message: 'Ticket actualizado', type: 'is-success'})
        dispatch('updated', resp.data)
    }

</script>

<Form on:submit={ updateTicket } on:canceled { loading } >

    <Textarea bind:value={ response }
        label="Nuevo comentario"
    />

    {#if $TicketStore.history && $TicketStore.history.length}
        <div class="columns">
            <div class="column">
                <div class="subtitle is-5">Historial</div>
                {#each data.history as item}
                    <hr>
                    <div class="space bottom">
                        <Value label= {EnumMethods.get(item.from)} value={ item.response } />
                        <br>
                        <div class="items end">
                            <Value value= { DateMethods.dateTimeLarge(item.created) } />
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    {/if}

</Form>